import { SideNavContent } from '@atlassian/navigation-system/layout/side-nav';
import { MenuList } from '@atlassian/navigation-system/side-nav/menu-list';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { ErrorBoundary } from '../../../common/error-boundary';
import { useAuthData } from '../../../utils/auth-context';
import { useTenantData } from '../../../utils/tenant-context';

import query, { type flowsQuery } from './components/__generated__/flowsQuery.graphql';
import { Flows } from './components/flows';

export const LayoutBoysenberrySidebar = () => {
	const { user } = useAuthData();
	const { tenantContexts } = useTenantData();
	const { cloudId } = tenantContexts[0];

	const [queryRef, loadQuery] = useQueryLoader<flowsQuery>(query);

	useEffect(() => {
		if (user?.accountId && cloudId) {
			loadQuery({
				creator: user.accountId,
				cloudId,
			});
		}
	}, [loadQuery, user?.accountId, cloudId]);

	return (
		<ErrorBoundary>
			<SideNavContent>
				<MenuList>
					<Flows queryRef={queryRef} />
				</MenuList>
			</SideNavContent>
		</ErrorBoundary>
	);
};
